import React, { Component } from 'react';
import { submit, isSubmitting } from 'redux-form';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';

import { visitorDetails } from './components/visitors/VisitorDetails';
import AddVisitorForm from 'components/shared/AddVisitorForm';
import VisitorMobile from './components/VisitorsMobile';
import VisitorTable from './components/VisitorsTable';

import { toFriendlyDateTimeString } from 'helpers/Formatter';
import { AccentColor } from 'helpers/AccentColorHelper';
import { colors } from 'helpers/ColorHelper';

import FlatButton from 'material-ui/FlatButton';

import TextField from 'material-ui/TextField';
import Toggle from 'material-ui/Toggle';

import MultiSelectExtended from 'components/shared/MultiSelectExtended';

import { isFilterInStrings } from 'helpers/StringHelper.js';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import * as landlordPropertiesActions from 'actions/landlordPropertiesActions';

export default withMobileDialog()(
  connect(
    store => ({
      visitors: store.landlordProperties.visitors,
      properties: store.landlordProperties.properties,
      submitting: isSubmitting('add_visitor')(store),
    }),
    { ...landlordPropertiesActions, submit }
  )(
    class LandlordVisitors extends Component {
      constructor(props) {
        super(props);
        this.state = {
          filter: 'All',
          typeFilter: '',
          filteredValue: '',
          filterClosed: true,
          showAllVisitors: false,
          visitorIsOpen: false,
          visitorDetails: null,
          selectedProperties: [],
          selectedPropertiesMultiSelect: [],
          tableData: [],
          containerSize: 'calc(100% - 140px)',
          drawerIsOpen: false,
          allowVisitorSubmit: false,
        };
      }

      componentDidMount = () => {
        this.getAllVisitors();
        this.props.getProperties({ for_multiselect: true });
      };

      componentDidUpdate(prevProps, prevState) {
        if (this.state.filteredValue !== prevState.filteredValue) {
          this.filterByProperty();
        }

        if (prevProps.visitors !== this.props.visitors) {
          this.setState({ tableData: this.props.visitors });
        }
      }

      toggleVisitorDialog = () => {
        this.setState({
          visitorDetails: null,
          visitorIsOpen: !this.state.visitorIsOpen,
          allowVisitorSubmit: this.state.visitorIsOpen,
        });
      };

      toggleVisitorDetailsDialog = visitorDetails => {
        this.setState({
          visitorIsOpen: !this.state.visitorIsOpen,
          visitorDetails,
        });
      };

      getAllVisitors = () => {
        let options = {};
        if (this.state.showAllVisitors) {
          options = { show_all: true };
        }

        this.props.getVisitors(options).then(() => {
          this.setState({ tableData: this.props.visitors });
        });
      };

      getTypeFilterType = e => {
        this.setState({
          typeFilter: e.target.value,
          filteredValue: e.target.value,
          tableData: this.filterTicketWithString(e.target.value),
        });
      };

      onPropertySelect = properties => {
        this.setState({
          selectedProperties: properties.map(property => property.label),
          selectedPropertiesMultiSelect: properties,
          filteredValue: '',
          typeFilter: '',
          tableData: this.props.visitors,
        });

        this.filterByProperty(properties.map(property => property.label), this.props.visitors);
      };

      filterByProperty = (propertyList = this.state.selectedProperties, visitors) => {
        let filteredVisitors = visitors || this.state.tableData;

        if (propertyList.length === 0) {
          this.setState({ tableData: filteredVisitors });
        } else {
          const selectedPropertiesSet = new Set();
          propertyList.forEach(property => selectedPropertiesSet.add(property));
          const filteredVisitors = visitors.filter(visitor =>
            selectedPropertiesSet.has(visitor.property)
          );

          this.setState({
            tableData: filteredVisitors,
          });
        }
      };

      addVisitor = formData => {
        return this.props.createOrUpdateVisitor(formData).then(() => {
          this.toggleVisitorDialog();
          this.props.getVisitors();
        });
      };

      checkInOrOutVisitor = (visitorId, checkedInOrOut) => {
        return this.props.createOrUpdateVisitor(checkedInOrOut, visitorId).then(() => {
          if (this.state.visitorIsOpen) {
            this.toggleVisitorDialog();
          }
          this.props.getVisitors();
        });
      };

      filterTicketWithString = filterBy => {
        return this.props.visitors.filter(item =>
          isFilterInStrings(
            [
              item.status,
              item.unit_number,
              item.property,
              item.full_name,
              toFriendlyDateTimeString(item.expected_arrival_at),
              toFriendlyDateTimeString(item.expected_departure_at),
            ],
            filterBy
          )
        );
      };

      filterTable = filterAction => {
        this.setState({
          typeFilter: filterAction,
          filteredValue: filterAction,
          tableData: this.filterTicketWithString(filterAction),
        });
      };

      toggleAllVisitors = () => {
        this.setState({ showAllVisitors: !this.state.showAllVisitors }, this.getAllVisitors);
      };

      allowVisitorSubmit = allowSubmit => {
        this.setState({ allowVisitorSubmit: allowSubmit });
      };

      render() {
        const propertySelector = (
          <MultiSelectExtended
            onChange={this.onPropertySelect}
            multiple
            name="property_select"
            hintText="Select properties to filter tickets"
            data={this.props.properties}
            menuStyle={{ fontSize: '14px' }}
            textFieldStyle={{ padding: 0 }}
            style={{ fontSize: '14px' }}
            minHeight={'32px'}
            fullWidth
            fireOnChangeIfBlank
            withResetSelectAllButtons
            value={this.state.selectedPropertiesMultiSelect}
          />
        );

        const toggle = (
          <Toggle
            label={'Show All'}
            labelPosition="right"
            style={{ marginTop: '10px' }}
            onToggle={this.toggleAllVisitors}
          />
        );

        const disableVisitorButton = this.props.submitting || !this.state.allowVisitorSubmit;

        return (
          <div className="body" role="main">
            <div className="centers">
              <div style={{ marginBottom: '5px' }}>
                <span className="page-title">Visitors</span>
                <span
                  style={{
                    color: AccentColor(),
                    fontFamily: 'Circular-Black',
                    fontSize: '25px',
                  }}
                >
                  .
                </span>
                <FlatButton
                  label="Add Visitor"
                  type="submit"
                  primary={true}
                  backgroundColor={AccentColor()}
                  hoverColor="grey"
                  onClick={this.toggleVisitorDialog}
                  style={{
                    color: 'white',
                    float: 'right',
                    height: '30px',
                    fontSize: '13px',
                    lineHeight: '30px',
                    marginTop: '3px',
                  }}
                />
              </div>

              <Dialog
                disableBackdropClick={!this.state.visitorDetails}
                fullScreen={this.props.fullScreen}
                open={this.state.visitorIsOpen}
                onClose={this.toggleVisitorDialog}
                aria-labelledby="add-new-visitor"
                classes={{
                  paper: 'form-dialog',
                }}
              >
                <DialogTitle id="add-new-visitor">
                  <h3 style={{ textAlign: 'center', margin: 0 }}>
                    {this.state.visitorDetails ? 'Visitor Details' : 'Add Visitor'}
                  </h3>
                </DialogTitle>
                <DialogContent>
                  {!this.state.visitorDetails && (
                    <AddVisitorForm
                      formName="add_visitor"
                      properties={this.props.properties}
                      onSubmit={this.addVisitor}
                      allowVisitorSubmit={this.allowVisitorSubmit}
                      showPropertySelector
                    />
                  )}
                  {this.state.visitorDetails && visitorDetails(this.state.visitorDetails)}
                </DialogContent>
                <DialogActions style={{ display: 'block', padding: '0 10px' }}>
                  <FlatButton
                    onClick={this.toggleVisitorDialog}
                    id="close-button"
                    style={{ color: AccentColor(), padding: '0 15px' }}
                  >
                    CLOSE
                  </FlatButton>
                  {!this.state.visitorDetails && (
                    <FlatButton
                      onClick={() => this.props.submit('add_visitor')}
                      disabled={disableVisitorButton}
                      id="submit-button"
                      style={{
                        color: 'white',
                        padding: '0 15px',
                        backgroundColor: disableVisitorButton ? colors.LIGHT_GRAY : AccentColor(),
                      }}
                    >
                      SAVE
                    </FlatButton>
                  )}
                  {this.state.visitorDetails &&
                    this.state.visitorDetails.status === 'checked_in' && (
                      <FlatButton
                        onClick={() =>
                          this.checkInOrOutVisitor(this.state.visitorDetails.id, {
                            check_out: true,
                          })}
                        disabled={this.props.submitting}
                        id="submit-button"
                        style={{
                          color: 'white',
                          padding: '0 15px',
                          backgroundColor: this.props.submitting
                            ? colors.LIGHT_GRAY
                            : AccentColor(),
                        }}
                      >
                        CHECK OUT
                      </FlatButton>
                    )}
                  {this.state.visitorDetails &&
                    this.state.visitorDetails.status === 'pending_arrival' && (
                      <FlatButton
                        onClick={() =>
                          this.checkInOrOutVisitor(this.state.visitorDetails.id, {
                            check_in: true,
                          })}
                        disabled={this.props.submitting}
                        id="submit-button"
                        style={{
                          color: 'white',
                          padding: '0 15px',
                          backgroundColor: this.props.submitting
                            ? colors.LIGHT_GRAY
                            : AccentColor(),
                        }}
                      >
                        CHECK IN
                      </FlatButton>
                    )}
                </DialogActions>
              </Dialog>

              <MediaQuery query="(max-device-width: 750px)">
                <div className="row" style={{ height: 'calc(100% - 27px)' }}>
                  <div
                    className="row"
                    style={{
                      margin: '0px -15px 0',
                      padding: '20px 15px 0px',
                      borderBottom: `1px solid ${colors.LIGHT_GRAY}`,
                    }}
                  >
                    {propertySelector}
                    <div style={{ height: '15px' }} />
                  </div>
                  <VisitorMobile
                    toggleVisitorDetailsDialog={this.toggleVisitorDetailsDialog}
                    createOrUpdateVisitor={this.props.createOrUpdateVisitor}
                    toggleVisitorDialog={this.toggleVisitorDialog}
                    optionsDropdown={this.state.visitorIsOpen}
                    data={this.state.tableData}
                  />
                </div>
              </MediaQuery>
              <MediaQuery query="(min-device-width: 750px)">
                <div className="row" style={{ height: this.state.containerSize }}>
                  <div className="row">
                    <TextField
                      hintText="Filter by Unit, Property, Ticket #, Subject..."
                      style={{ fontSize: '13px' }}
                      value={this.state.typeFilter}
                      onChange={this.getTypeFilterType}
                    />
                  </div>
                  <div className="row" style={{ marginBottom: '15px' }}>
                    <div style={{ width: '250px', float: 'right' }}>{propertySelector}</div>
                    <div style={{ width: '135px' }}>{toggle}</div>
                  </div>
                  <VisitorTable
                    createOrUpdateVisitor={this.props.createOrUpdateVisitor}
                    toggleVisitorDetailsDialog={this.toggleVisitorDetailsDialog}
                    toggleVisitorDialog={this.toggleVisitorDialog}
                    optionsDropdown={this.state.visitorIsOpen}
                    data={this.state.tableData}
                  />
                </div>
                <div style={{ height: '10px' }} />
              </MediaQuery>
            </div>
          </div>
        );
      }
    }
  )
);
